/**
 * Experience Mode Utility
 * 
 * Simple sessionStorage-based mode persistence with URL cleaning.
 */

const DEFAULT_STORAGE_KEY = 'experience_mode';

/**
 * Get the stored experience mode from sessionStorage.
 */
export function getExperienceMode(storageKey = DEFAULT_STORAGE_KEY): string | null {
  try {
    return sessionStorage.getItem(storageKey);
  } catch {
    return null;
  }
}

/**
 * Set the experience mode in sessionStorage.
 */
export function setExperienceMode(mode: string, storageKey = DEFAULT_STORAGE_KEY): void {
  try {
    sessionStorage.setItem(storageKey, mode);
  } catch {
    // sessionStorage not available
  }
}

/**
 * Clear the experience mode from sessionStorage.
 */
export function clearExperienceMode(storageKey = DEFAULT_STORAGE_KEY): void {
  try {
    sessionStorage.removeItem(storageKey);
  } catch {
    // sessionStorage not available
  }
}


/**
 * Clean a path prefix from the current URL, preserving query params and hash.
 */
export function cleanUrlPath(pathPrefix: string): void {
  if (typeof window === 'undefined') return;
  
  const url = new URL(window.location.href);
  const pathname = url.pathname;
  
  if (!pathname.startsWith(pathPrefix)) return;
  
  // Remove the path prefix, keeping any trailing path
  let newPath = '/';
  if (pathname.startsWith(`${pathPrefix}/`)) {
    newPath = pathname.slice(pathPrefix.length) || '/';
  }
  
  url.pathname = newPath;
  history.replaceState(null, '', url.toString());
}
